import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { existenciaCotizacion, notificarCotizacion, cotizacionDetalleCheckout, validarCupon, removerCupon, } from "../../../services/backend/cotizacionService";
import logger from "../../../shared/utils/logger";

const useCheckoutNavigation = ({ cotizacionId, appUser, toastRef }) => {
  const navigate = useNavigate();
  const [continueLoading, setContinueLoading] = useState(false);

  const proceedCheckoutRequest = useCallback(async ({ selectedItems, selectedTotal }) => {
    const itemsWithoutPrice = selectedItems.filter((item) => Number(item?.price || 0) <= 0);
    if (itemsWithoutPrice.length) {
      const itemsPreview = itemsWithoutPrice
        .slice(0, 3)
        .map((item) => item?.name || item?.code || "Producto sin nombre")
        .join(", ");
      toastRef.current?.show({
        severity: "error",
        summary: "No se puede continuar",
        detail: `Hay productos sin precio: ${itemsPreview}${itemsWithoutPrice.length > 3 ? "..." : ""}.`,
        life: 3600,
      });
      return;
    }
    if (!cotizacionId) {
      toastRef.current?.show({
        severity: "error",
        summary: "No se pudo continuar",
        detail: "No se encontró una cotización activa.",
        life: 2800,
      });
      return;
    }

    await Promise.all([
       notificarCotizacion(cotizacionId),
       existenciaCotizacion(cotizacionId),
    ]);

    try {
      const detalle = await cotizacionDetalleCheckout({ id_cotizacion: cotizacionId });
      if (detalle?.tieneCupon && detalle?.cupon?.codigo) {
        const validarResponse = await validarCupon(detalle.cupon.codigo);
        if (validarResponse?.valido === false) {
          await removerCupon({ id_cotizacion: cotizacionId });
          toastRef.current?.show({
            severity: "info",
            summary: "Cupón inválido",
            detail: "El cupón aplicado no es válido y ha sido removido de la cotización.",
            life: 4000,
          });
        }
      }
    } catch (error) {
      logger.error("Error al validar cupón en checkout:", error);
    }

    navigate("/checkout", {
      state: { selectedItems, selectedTotal },
    });
  }, [cotizacionId, navigate, toastRef]);

  const handleContinueCheckout = useCallback(async ({ selectedItems, selectedTotal }) => {
    if (!selectedItems?.length || continueLoading) {
      return;
    }
    setContinueLoading(true);
    try {
      await proceedCheckoutRequest({ selectedItems, selectedTotal });
    } catch (error) {
      toastRef.current?.show({
        severity: "error",
        summary: "No se pudo continuar",
        detail: error?.message || "Falló la validación de cotización.",
        life: 3200,
      });
    } finally {
      setContinueLoading(false);
    }
  }, [continueLoading, proceedCheckoutRequest, toastRef]);

  return {
    continueLoading,
    handleContinueCheckout,
  };
};

export default useCheckoutNavigation;
